import { GeometryEditorComponent } from './../../../components/geometry-editor/geometry-editor.component';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Lightbox } from 'ngx-lightbox';

import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Point,Polygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import * as shpwrite from '@aleffabricio/shp-write';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import EditableReport from '../report-edition-interface';
import { DomSanitizer } from '@angular/platform-browser';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { ReportsService } from './../../../apiclient/api/reports.service';
import { NbDialogService } from '@nebular/theme';

/**
 * Componente que renderiza el detalle de informe de tipo Plaga
 */
@Component({
  selector: 'ngx-disease-lite',
  templateUrl: './disease-lite.component.html',
  styleUrls: ['./disease-lite.component.scss']
})
export class DiseaseLiteComponent implements OnInit,AfterViewInit,EditableReport {

  dropdownSettings={};  //Esther EV2022-02
  selectedItem = [];  //Esther EV2022-02

  report: any = {};

  map: Map;
  feature: Feature;
  vectorSource: VectorSource;
  config: any = {
    target: 'visormapreport',
    center : [-5.6954768,40.9670626],
  }

  diseases: [any]
  geometryEditable = false
  editionEnabled: Boolean;

  /**
   * Carga el reporte en el detalle
   */
  @Input()
  set loadReport(val: any){

    this.userSessionService.getCachedDiseaseList().subscribe(diseases => {

        this.diseases = diseases

        this.report = JSON.parse(JSON.stringify(val));
        moment.locale('es')
        this.report.diseaseUser = this.report.diseaseUser.name +" "+this.report.diseaseUser.surname;
        this.report.datetime = moment(this.report.datetime).format('DD/MM/YYYY, HH:mm');

        this.report.temperature = Number(this.report.temperature).toFixed(2);   //Esther 19/01/2022
        this.report.humidity = Number(this.report.humidity).toFixed(2);   //Esther 19/01/2022

        if(this.report.imagen != '' && null != this.report.imagen){
          this.report.imageToSave = this.report.imagen
          this.report.imagen = 'https://api.smartrural.es:8084/v1/image/report' + this.report.imagen;
          this.report.imageToShow = this.report.imagen + '?th=true'
        }


        if(this.report.showLocation && typeof this.vectorSource != 'undefined'){
          this.vectorSource.clear();
          this.loadLocation()
        }
        this.selectedItem = [];  //Esther EV2022-02
        this.selectedItem.push({"id": this.report.disease,"name":this.report.diseaseName});  //Esther EV2022-02
     })
  }

  constructor(private lightbox: Lightbox,
    private userSessionService: UserSessionService,
    private reportService: ReportsService,
    private sanitizer: DomSanitizer,
    private dialogService: NbDialogService) { }
  enableEdition(enableEd: Boolean): void {
    this.editionEnabled = enableEd;
  }
    /**
     * @ignore
     */
  canEdit(): Boolean {
    throw new Error('Method not implemented.');
  }
  /**
   * Guarda el reporte
   * @returns
   */
  async saveReport(): Promise<any> {
    return new Promise((resolve,reject) => {
      var reportToSave = JSON.parse(JSON.stringify(this.report));
      reportToSave.disease = this.selectedItem[0].id
      if (null != reportToSave.imageToSave) {
        reportToSave.imagen = reportToSave.imageToSave
        delete reportToSave.imageToSave
      }

      if (null == reportToSave.imagen){
        delete reportToSave.imagen
      }
      reportToSave.localizacion = JSON.stringify(reportToSave.localizacion)
      reportToSave.humidity = parseFloat(reportToSave.humidity)
      reportToSave.temperature = parseFloat(reportToSave.temperature)
      this.reportService.updatediseasereport(this.report.id,reportToSave,this.userSessionService.accessToken).subscribe(report => {
          resolve(true);
      })
    })
  }
  /**
   * Elimina el reporte
   * @returns
   */
  async deleteReport(): Promise<any> {
    return new Promise((resolve,reject) => {
      this.reportService.deletediseasereport(this.report.id,this.userSessionService.accessToken).subscribe(report => {
          resolve(true);
      })
    })
  }


  /**
   * @ignore
   */
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: true,
      selectAllText:'Select All',
      unSelectAllText:'UnSelect All',
      enableSearchFilter: true,
      labelKey:"name",
      searchPlaceholderText:"Tipo de plaga",
      text:"Tipo de plaga"
    };  //Esther EV2022-02

  }

  //Esther EV2022-02
  OnItemDeSelect(items: any){
    this.selectedItem.push({"id": this.report.disease,"name":this.report.diseaseName});
    }
  //Esther EV2022-02
  onDeSelectAll(items: any){
    this.selectedItem.push({"id": this.report.disease,"name":this.report.diseaseName});
    }

  open(i){
    console.log("Queremos abrir la imagen "+i);
    var fotos = [{src:i,thumb:i}]
    this.lightbox.open(fotos,0);
  }

  initMap() {
    console.log("Inicializamos el mapa")
    this.vectorSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
          source: new OSM(),
        }) ,
        new TileLayer({
          visible: true,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new VectorLayer({
          source: this.vectorSource,
        }),
      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    console.log("Mapa inicializado")
  }
  ngAfterViewInit(): void {
    this.initMap();

    if(this.report.showLocation){

      this.loadLocation()
    }

  }

  loadLocation() {
    var coordinates = [];
    this.geometryEditable = false
      coordinates = JSON.parse(JSON.stringify(this.report.localizacion.coordinates));

      console.log(this.report.localizacion)
    if(this.report.localizacion.type === "Polygon"){
      this.geometryEditable = true
      coordinates[0] = coordinates[0].map(function(coordinate){
        return olProj.fromLonLat(coordinate);
      })



      console.log (coordinates)
      var iconFeature = new Feature({
        geometry: new Polygon(
          coordinates),
        name: this.report.diseaseName,

        informe: this.report,
      });



      iconFeature.setStyle(new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.1)',
        }),
      }));
    }else{

      var iconFeature = new Feature({
        geometry: new Point(
          olProj.fromLonLat(coordinates)),
        name: this.report.diseaseName,

        informe: this.report,
      });



      iconFeature.setStyle(new Style({
        image: new Icon({
          color: '#32CD32',
          crossOrigin: 'anonymous',
          src: 'assets/images/marker_disease.png',
          scale: 0.5,
        }),
      }));
    }



    this.vectorSource.addFeature(iconFeature);

    this.map.getView().fit(this.vectorSource.getExtent(),this.map.getSize())
    this.map.getView().setZoom(15);

  }

  actualizarImagen(archivos: FileList){



    this.report.imageToShow = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(archivos.item(0)));
    this.report.imagen = this.report.imageToShow
    const file = archivos.item(0)
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

        this.report.imageToSave = 'dataImageName:/'+this.userSessionService.user.company.id+'/'+this.userSessionService.user.id+'/'+file.name+';'
        + (reader.result as String).split(',')[1]
        console.log(reader.result);
    };

  }

  async editGeometry(){
   var editorref = await  this.dialogService.open(GeometryEditorComponent)
   editorref.componentRef.instance.cargarGeometria(this.report.localizacion)
   editorref.componentRef.instance.getGeometry().subscribe( geo => {
     console.log(geo);
     this.report.localizacion = geo
     this.vectorSource.clear()
     this.loadLocation();
   })
  }
}
